import PatientAccountContainer from './PatientAccountContainer';

export default PatientAccountContainer;
